import { useCallback } from 'react';
import { useAppDispatch } from '#components/redux/hooks';
import { setIsContentHeightAuto } from '#base/reducers';

const useBaseContentControl = () => {
  const dispatch = useAppDispatch();

  const setIsContentHeightAutoFn = useCallback((isContentHeightAuto: boolean) => {
    dispatch(setIsContentHeightAuto(isContentHeightAuto));
  }, [dispatch]);

  return {
    setIsContentHeightAuto: setIsContentHeightAutoFn,
  };
};

export { useBaseContentControl };
